import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class MultiMediaService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getDataFromServer(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `multi-media`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewItemToServer(title, videoLink) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `multi-media`,
                {
                    title,
                    videoLink
                }
            ).then(resolve).catch(reject)
        })
    }

    getVideoDetailFromServer(id) {
        const globalInfoReq = this.httpClient.get(
            `multi-media/${id}/information`
        )

        const publishedReq = this.httpClient.get(
            `multi-media/${id}/published`
        )

        const request = [globalInfoReq, publishedReq]

        return new Promise((resolve, reject) => {
            axios.all(request)
                .then(axios.spread((globalInfo, published) => {
                    resolve({globalInfo, published})
                })).catch(reject)
        })
    }

    updateMultiMediaGlobalInfo(id, title, videoLink, shortDescription) {
        return new Promise((resolve, reject) => [
            this.httpClient.put(
                `multi-media/${id}/information`,
                {
                    title,
                    shortDescription,
                    videoLink
                }
            ).then(resolve).catch(reject)
        ])
    }

    updateMultiMediaPublished(id, published,publishDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `multi-media/${id}/published`,
                {},
                {
                    published,
                    publishDate
                }
            ).then(resolve).catch(reject)
        })
    }

    getVideoThumbnailInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `multi-media/${id}/thumbnails`
            ).then(resolve).catch(reject)
        })
    }

    updateMultiMediaThumbnail(id, file) {
        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `multi-media/${id}/thumbnails`,
                {},
                data
            ).then(resolve).catch(reject)
        })
    }
}